import { type ChangeEvent } from 'react';
import { usePlacesWidget } from 'react-google-autocomplete';
import TextField from '../TextField/TextField';
import { parseAddress } from '@/helpers/addressParser';
import type { AddressInputProps } from './IAddressInput';

const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_KEY;

const AddressInput = ({
    value,
    onChange,
    onSelect,
    countries = ['us', 'ca'],
    ...rest
}: AddressInputProps) => {
    const { ref } = usePlacesWidget<HTMLInputElement>({
        apiKey: GOOGLE_MAPS_API_KEY,
        onPlaceSelected: (place) => {
            if (!place) return;
            onSelect(parseAddress(place));
        },
        options: {
            componentRestrictions: { country: countries },
            types: ['address'],
        },
    });

    return (
        <TextField
            {...rest}
            value={value}
            onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
            inputRef={ref}
        />
    );
};

export default AddressInput;
